<template>
  <div class="help-card-wrap-2">
    <div class="help-card-description">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
  .help-card-wrap-2 {
    position: relative;
    width: 100%;
    padding: 8px 16px;
    margin: 0 0 10px 0;
    box-sizing: border-box;
    border-radius: 8px;
    background: #FFFBE8;
    overflow: hidden;
    opacity: 1;
    display: flex;
    align-items: center;
    transition: opacity .2s;
    .help-card-description {
      margin: 5px 0 0 0;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9B6C1E;
      line-height: 17px;
    .link-doc {
        cursor: pointer;
        text-decoration: underline;
        color: #3192F1;
        &:hover {
          opacity: 0.8;
        }
      }
    }
    .help-card-close {
      font-size: 18px;
    }
  }
</style>